import client from "../client";

export const getBranches = () => client.get("/get-all-branches");
export const createBranch = (data) => client.post("/create-branch", data);
export const updateBranch = (id, data) => client.put(`/edit-branch/${id}`, data);
export const deleteBranch = (id) => client.delete(`/delete-branch/${id}`);
export const updateUserBranch = (branchId) => client.put("/update-user-branch", { branchId });
